import { type AdChannel, type DestinationType, channelDestinationError } from '../campaignChannels';
import './campaign-channel-settings.css';

interface Props {
  channels: AdChannel[];
  destination: DestinationType;
  onDestinationChange: (value: DestinationType) => void;
  landingUrl: string;
  onLandingUrlChange: (value: string) => void;
  whatsappNumber: string;
  onWhatsappNumberChange: (value: string) => void;
}

const destinations: { id: DestinationType; title: string; description: string; metaOnly?: boolean }[] = [
  { id: 'whatsapp', title: 'WhatsApp direto', description: 'Abre uma conversa pelo anúncio da Meta.', metaOnly: true },
  { id: 'lead_form', title: 'Formulário instantâneo Meta', description: 'Capta o contato no Facebook ou Instagram.', metaOnly: true },
  { id: 'landing_page', title: 'Landing page / Site', description: 'Direciona ao site ou página com formulário.' },
  { id: 'checkout', title: 'Checkout', description: 'Direciona à página de contratação ou pagamento.' },
];

export function CampaignTrafficDestination(props: Props) {
  const google = props.channels.includes('google');
  const error = channelDestinationError(props.channels, props.destination, props.landingUrl);
  return <div className="campaign-channel-destination">
    <strong>Destino do anúncio</strong>
    <div className="campaign-channel-grid">
      {destinations.map(item => <button type="button" key={item.id}
        className="campaign-channel-option" aria-pressed={props.destination === item.id}
        data-selected={props.destination === item.id} disabled={google && item.metaOnly}
        onClick={() => props.onDestinationChange(item.id)}>
        <strong>{item.title}</strong><span>{item.description}</span>
        {item.metaOnly && <small>Exclusivo Meta Ads</small>}
      </button>)}
    </div>
    {props.destination === 'whatsapp' ? <label className="campaign-channel-field">WhatsApp com DDI e DDD
      <input type="tel" value={props.whatsappNumber} onChange={event => props.onWhatsappNumberChange(event.target.value)} placeholder="5511999999999" />
    </label> : props.destination === 'lead_form' ? <p>O contato preenche o formulário dentro do Facebook ou Instagram.</p>
      : <label className="campaign-channel-field">{props.destination === 'checkout' ? 'URL do checkout' : 'URL do site / landing page'}
        <input type="url" value={props.landingUrl} onChange={event => props.onLandingUrlChange(event.target.value)} placeholder="https://seusite.com.br" />
      </label>}
    {google && <small>Google Ads de Pesquisa usa uma URL HTTPS. Para WhatsApp ou captação, use uma página com esse contato ou formulário.</small>}
    {error && <p role="alert" className="campaign-channel-error">{error}</p>}
  </div>;
}
